export const WEB_USER_ID = 'WEB_USER_ID';
export const DRIVER_USER_ID = 'DRIVER_USER_ID';
